var map = {
	"./en/about.md": "9e97",
	"./en/article.md": "2419",
	"./en/contacts.md": "fbc4",
	"./en/editors.md": "8136",
	"./en/ethics.md": "c90d",
	"./en/instructions.md": "d917",
	"./en/journals.md": "83a8",
	"./en/journals/JEBT/about.md": "e3de",
	"./en/journals/JEBT/editors.md": "7b4e",
	"./en/journals/JEBT/ethics.md": "4ce6",
	"./en/journals/JEBT/index.md": "b979",
	"./en/journals/JEBT/instructions.md": "c7e9",
	"./en/journals/JEBT/peer-review.md": "2052",
	"./en/journals/index.md": "cc41",
	"./en/journals/templates/subscription-request-confirmation.md": "6a5c",
	"./en/journals/templates/subscription-request-notification.md": "f2f9",
	"./en/login/index.md": "edfc",
	"./en/login/login.md": "ba09",
	"./en/login/reset-sent.md": "ffff",
	"./en/login/reset.md": "30e8",
	"./en/login/sign-up.md": "bc7b",
	"./en/peer-review.md": "8421",
	"./en/profile.md": "dcf1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8d7b";